"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION = void 0;
/**
 * Version configuration
 * Update this whenever you make a major change
 */
exports.VERSION = "1.5.0";
